import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton, { listItemButtonClasses } from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { React, useEffect } from 'react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { userRoles as ur } from '../assets/const/userRole';
import DashboardIcon from '../assets/images/icons/dashboard.svg';
import DemandManagerIcon from '../assets/images/icons/demandManager.svg';
import ReportsIcon from '../assets/images/icons/reports.svg';
import RoutesIcon from '../assets/images/icons/routes.svg';
import SettingsIcon from '../assets/images/icons/settings.svg';
import SupplyManagerIcon from '../assets/images/icons/supplyManager.svg';
import SupportIcon from '../assets/images/icons/support.svg';
import NotificationsIcon from '../assets/images/icons/notifications.svg';
import { getLoggedInUser } from '../auth/authUtil';
import logo from '../logo-120x30.svg';
import { UserProfile } from './UserProfile';
import { useSelector } from 'react-redux';
import { DEMAND, DEMAND_PARTNER, ROUTES, SUPPLY, SUPPLY_PARTNER } from '../assets/const/reportTypeConst';

function LeftSideBar(props) {
    const { window } = props;
    const [open, setOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [supplyOpen, setSupplyOpen] = useState(false);
    const [demandOpen, setDemandOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const drawerWidth = open ? 70 : 270;
    let user = getLoggedInUser();
    const location = useLocation();
    const companyLogo = useSelector(state => state.company.companyLogo);
    const notifications = useSelector(state => state.notifications.storenotification);
    const notificationCount = notifications.filter(notification => notification.markStatus === true).length;

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        let type = location.pathname.split("/")[1];
        let index = 0;
        switch (type) {
            case SUPPLY_PARTNER:
                index = 1;
                setSupplyOpen(true);
                break;
            case SUPPLY:
                index = 2;
                setSupplyOpen(true);
                break;
            case DEMAND_PARTNER:
                index = 3;
                setDemandOpen(true);
                break;
            case DEMAND:
                index = 4;
                setDemandOpen(true);
                break;
            case ROUTES:
                index = 5;
                break;
            case "reports":
                index = 6;
                break;
            case "support":
                index = 7;
                break;
            case "settings":
            case "company":
            case "users":
            case "billing":
            case "billing-history":
            case "profile":
                index = 8
                break;
            default:
                break;
        }

        if (index != 1 && index != 2 && index != 3 & index != 4) {
            setDemandOpen(false);
            setSupplyOpen(false);
        }
        
        setSelectedIndex(index);
    }, [location.pathname])

    const handleDrawerClose = () => {
        if (drawerWidth === 270) {
            setOpen(!open);
            setSupplyOpen(false);
            setDemandOpen(false);
        } else {
            setOpen(false);
        }
    };

    const handleSupplyClick = () => {

        setOpen(open);
        setSupplyOpen(!supplyOpen);
        setDemandOpen(false);

    };

    const handleDemandClick = () => {
        setOpen(open);
        setDemandOpen(!demandOpen);
        setSupplyOpen(false);
    };

    const handleListItemClick = (event, index) => {
        if (index != 1 && index != 2 && index != 3 & index != 4) {
            setDemandOpen(false);
            setSupplyOpen(false);
        }
        setSelectedIndex(index);
    };

    const isAuthorized = (route) => {
        let isAuth = false;
        for (let i = 0; i < user?.authorities?.length; i++) {
            if (route.includes(user?.authorities[i])) {
                isAuth = true;
            }
        }
        return isAuth;
    }

    const drawer = (
        <Box sx={{
            minHeight: 0,
            overflow: 'hidden auto',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            paddingX: '1rem',
            [`& .${listItemButtonClasses.root}`]: {
                gap: 0.25,
            },
        }}>
            <Toolbar className='menu-toolbar main-content-header'>
                <Box sx={{ display: open ? 'none' : 'flex', gap: 1, alignItems: 'center' }} className="logo-wrapper">
                    <img src={companyLogo || logo} className='brand-logo' alt="logo" />
                </Box>
            </Toolbar>
            <List
                size="sm"
                sx={{
                    width: '100%', maxWidth: 360, bgcolor: 'background.paper', gap: 1, flexGrow: 1, overflow: 'hidden auto',
                    '--List-nestedInsetStart': '30px'
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
            >
                <ListItemButton component={Link}
                    to="/dashboard"
                    selected={selectedIndex === 0}
                    onClick={(event) => handleListItemClick(event, 0)}>
                    <ListItemIcon>
                        <Button className='link-style-2' tooltip={open ? "Dashboard" : ""}
                            tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}
                        >
                            <Image src={DashboardIcon} alt="Image" width="24" />
                        </Button>
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" className='fs-1' />
                </ListItemButton>

                {/* ..........Supply............. */}
                {
                    isAuthorized([ur.ROLE_ADMIN, ur.ROLE_INTERMEDIARY_SUPPLY, ur.ROLE_INTERMEDIARY_ADMIN]) ?
                        <div>
                            <ListItemButton
                                selected={selectedIndex === 1}
                                component={Link} to="/supply-partner"
                                onClick={(event) => { handleListItemClick(event, 1); handleSupplyClick() }}>
                                <ListItemIcon>
                                    <Button className='link-style-2' tooltip={open ? "Supply Manager" : ""}
                                        tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}>
                                        <Image src={SupplyManagerIcon} alt="Image" width="24" /></Button>
                                </ListItemIcon>
                                <ListItemText primary="Supply Manager" className='fs-1' />
                                {supplyOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>

                            <Collapse in={supplyOpen} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding className='t-indent-3'>
                                    <ListItemButton sx={{ pl: 4 }} component={Link} to="/supply-partner"
                                        selected={selectedIndex === 1}
                                        onClick={(event) => handleListItemClick(event, 1)} >
                                        <ListItemText primary="Supply Partner " className='fs-1' />
                                    </ListItemButton>
                                    <ListItemButton sx={{ pl: 4 }} component={Link} to="/supply"
                                        selected={selectedIndex === 2}
                                        onClick={(event) => handleListItemClick(event, 2)}>
                                        <ListItemText primary="Supply" className='fs-1' />
                                    </ListItemButton>
                                </List>
                            </Collapse>
                        </div>
                        : <div></div>
                }

                {/* .............Demand...................... */}
                {
                    isAuthorized([ur.ROLE_ADMIN, ur.ROLE_INTERMEDIARY_DEMAND, ur.ROLE_INTERMEDIARY_ADMIN]) ?
                        <div>
                            <ListItemButton
                                selected={selectedIndex === 3}
                                component={Link} to="/demand-partner"
                                onClick={(event) => { handleListItemClick(event, 3); handleDemandClick() }} >
                                <ListItemIcon>
                                    <Button className='link-style-2' tooltip={open ? "Demand Manager" : ""}
                                        tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}><Image src={DemandManagerIcon} alt="Image" width="24" /></Button>
                                </ListItemIcon>
                                <ListItemText primary="Demand Manager" className='fs-1' />
                                {demandOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={demandOpen} timeout="auto" unmountOnExit className='t-indent-3'>
                                <List component="div" disablePadding>
                                    <ListItemButton sx={{ pl: 4 }} component={Link} to="/demand-partner"
                                        selected={selectedIndex === 3}
                                        onClick={(event) => handleListItemClick(event, 3)}>
                                        <ListItemText primary="Demand Partner" className='fs-1' />
                                    </ListItemButton>
                                    <ListItemButton sx={{ pl: 4 }} component={Link} to="/demand"
                                        selected={selectedIndex === 4}
                                        onClick={(event) => handleListItemClick(event, 4)}>
                                        <ListItemText primary="Demand" className='fs-1' />
                                    </ListItemButton>
                                </List>
                            </Collapse>
                        </div>
                        : <div></div>
                }
                {
                    /*........... Routes............ */

                    isAuthorized([ur.ROLE_ADMIN, ur.ROLE_INTERMEDIARY_DEMAND, ur.ROLE_INTERMEDIARY_ADMIN]) ?

                        <ListItemButton component={Link} to="/routes" selected={selectedIndex === 5}
                            onClick={(event) => handleListItemClick(event, 5)}>
                            <ListItemIcon>
                                <Button className='link-style-2' tooltip={open ? "Routes" : ""} tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}><Image src={RoutesIcon} alt="Image" width="24" /></Button>
                            </ListItemIcon>
                            <ListItemText primary="Routes" className='fs-1' />
                        </ListItemButton>
                        : <div></div>

                }
                {/*........... Report............ */}
                {
                    isAuthorized([ur.ROLE_ADMIN, ur.ROLE_INTERMEDIARY_DEMAND, ur.ROLE_INTERMEDIARY_ADMIN, ur.ROLE_INTERMEDIARY_SUPPLY, ur.ROLE_INTERMEDIARY_REPORT]) ?
                        <ListItemButton component={Link} to="/reports/supply-partner" selected={selectedIndex === 6}
                            onClick={(event) => handleListItemClick(event, 6)}>
                            <ListItemIcon>
                                <Button className='link-style-2' tooltip={open ? "Reports" : ""} tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}><Image src={ReportsIcon} alt="Image" width="24" /></Button>
                            </ListItemIcon>
                            <ListItemText primary="Reports" className='fs-1' />
                        </ListItemButton>
                        : null
                }

                {/*........... Support............ */}
                <ListItemButton component={Link} to="/support" selected={selectedIndex === 7}
                    onClick={(event) => handleListItemClick(event, 7)}>
                    <ListItemIcon>
                        <Button className='link-style-2' tooltip={open ? "Support" : ""} tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}><Image src={SupportIcon} alt="Image" width="24" /></Button>
                    </ListItemIcon>
                    <ListItemText primary="Support" className='fs-1' />
                </ListItemButton>

                {/*........... Settings............ */}
                <ListItemButton component={Link} to="/settings" selected={selectedIndex === 8}
                    onClick={(event) => handleListItemClick(event, 8)}>
                    <ListItemIcon>
                        <Button className='link-style-2' tooltip={open ? "Settings" : ""} tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}><Image src={SettingsIcon} alt="Image" width="24" /></Button>
                    </ListItemIcon>
                    <ListItemText primary="Settings" className='fs-1' />
                </ListItemButton>
            </List>

            {/* ................features........................ */}
            {/* <Feature /> */}

            {/* ...............notification................ */}
            <List
                size="sm"
                sx={{
                    width: '100%', maxWidth: 360, bgcolor: 'background.paper', gap: 1, flexGrow: 1, overflow: 'hidden auto',
                    '--List-nestedInsetStart': '30px'
                }}
                className='notifications-btn'
                component="nav"
                aria-labelledby="nested-list-subheader">

                <ListItemButton component={Link} to="/notifications" selected={selectedIndex === 14}
                    onClick={(event) => handleListItemClick(event, 14)}>
                    <ListItemIcon>
                        <Button className='link-style-2' tooltip={open ? "Notifications" : ""} tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15, showDelay: 0, hideDelay: 0 }}><Image src={NotificationsIcon} alt="Image" width="24" /></Button>
                    </ListItemIcon>
                    <ListItemText primary="Notifications" className='fs-1' />
                    {notificationCount > 0 && (
                    <span className={drawerWidth == 70 ? 'total-notifications-collapse' : 'total-notifications'}>{notificationCount}</span>
                    )}
                </ListItemButton>
            </List>

            <Divider />

            {/* ................user profile............. */}
            <UserProfile />
        </Box>
    );

    return (
        <div>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    bgcolor: "#fff",
                    color: "#000",
                    boxShadow: "none"
                }}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}>
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders">
                <Drawer
                    container={window !== undefined ? () => window().document.body : undefined}
                    variant="permanent"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{ keepMounted: true }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        width: drawerWidth, flexShrink: 0, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}>
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open={open}>
                    {drawer}
                </Drawer>
            </Box>
        </div>
    );
}

export default LeftSideBar;